import { SkipOrArgs } from '@common/types/queryState';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { MediaObjectQuality, MediaObjectType } from '../types/media';
import {
    useClipMediaResolver,
    UseClipMediaResolverArgs,
} from './useClipMediaResolver';
import { useSelectedClip } from './useSelectedClipSelectors';

export const useSelectedClipMediaResolver = (
    type: MediaObjectType,
    quality: MediaObjectQuality,
) => {
    const { selectedClip } = useSelectedClip();
    const queryArgs: SkipOrArgs<UseClipMediaResolverArgs> = useMemo(() => {
        if (
            !selectedClip ||
            !selectedClip.mediaObjectId ||
            !selectedClip.mediaIdentifiers?.[type]?.[quality]?.id
        )
            return skipToken;

        return {
            mediaObjectId: selectedClip.mediaObjectId,
            moiId: selectedClip.mediaIdentifiers[type][quality].id,
        };
    }, [quality, selectedClip, type]);

    return useClipMediaResolver(queryArgs);
};
